import React, { useMemo, useState } from 'react';
import { 
  MDBBtn, 
  MDBRow,
  MDBCol,
  MDBCheckbox
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

// Information content for lecture submission
const informationContent = [
  {
    language: "de",
    content: `
    <h3>Vortragseinreichung für die LOUNGES 2027</h3>

    <p className="text-muted">Bevor Du mit der Einreichung beginnst, lese die nachfolgenden Informationen bitte sorgfältig durch.</p>
    <p><strong>Beachte bitte auch:</strong> Nur wenn genannte Termine und Standards eingehalten werden, kann der Vortrag angenommen werden. Es wird keine Ausnahmen geben.</p>

    <h5>Wichtige Termine</h5>
    <ul>
        <li><strong>Beginn der Einreichung:</strong> 15. August 2026</li>
        <li><strong>Einreichungsschluss:</strong> 30. November 2026</li>
        <li><strong>Bestätigungsfrist eingereichter/unvollständiger Vorträge:</strong> 30. November 2026</li>
        <li><strong>Keine Einreichungen mehr ab:</strong> 1. Dezember 2026</li>
    </ul>
      <br />
    <h4>Vortragsarten</h4>
    <p>Folgende vier Vortragskategorien stehen zur Auswahl.</p>

    <h6><strong>VIP-Vortrag</strong></h6>
    <ul>
        <li>Vortrag gemeinsam mit einem Behördenvertreter</li>
        <li>Oder Vortrag über Projekte, die gemeinsam mit dem Kunden umgesetzt werden/wurden und gemeinsam mit mindestens 2 Personen auch vorgetragen werden</li>
        <li>Kunde bedeutet hier: Arzneimittelhersteller</li>
        <li>Vortrag wird auf der Internetseite sowie zusätzlich separat über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Studiobühne oder ECV-Stage</li>
    </ul>

    <h6><strong>Fachvortrag *</strong></h6>
    <ul>
        <li>Expertenwissen, Forschungsergebnisse, Guidelines, Innovationen, Kundenprojekte</li>
        <li>Vortrag wird auf der Internetseite sowie über das Programm über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Vortragsraum 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Schulungsvortrag *</strong></h6>
    <ul>
        <li>Spezifisches Wissen, Fähigkeiten, Kompetenzen. Dient zur Schulung von Einsteigern bis Experten</li>
        <li>Vortrag wird auf der Internetseite sowie über das Programm über LinkedIn und anderen Medien einzeln beworben</li>
        <li>Vortragsraum 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Marketingvortrag</strong></h6>
    <ul>
        <li>Wert und Nutzen von Produkten, Dienstleistungen, Ideen. Präsentation der Marke. Für potenzielle Kunden, Geschäftspartner.</li>
        <li>Vortrag wird auf der Internetseite beworben</li>
        <li>Offener Vortragsbereich 4,5</li>
    </ul>

    <p><strong>Bitte beachten:</strong> VIP-, Fach- und Schulungsvorträge werden generell aufgezeichnet.</p>

    <p><em>*In Ausnahmefällen können diese auch auf Wunsch nicht aufgezeichnet werden. Sie kommen dann zunächst auf eine Warteliste und werden bei der Programmgestaltung erst ganz zum Schluss dem Zeitplan zugeordnet, falls noch freie Plätze vorhanden sind. Offener Vortragsbereich 9</em></p>

    <h5>Wichtiger Hinweis zu den Aufzeichnungen und Nutzungsrechten</h5>
    <p>VIP-, Fach- und Schulungsvorträge werden per Audio und Video aufgezeichnet. Die Aufzeichnungsrechte gehören der Inspire GmbH und werden Teilnehmern sowie Nicht-Teilnehmern auf der Online-Plattform angeboten. Der Zugang zu den Aufzeichnungen kann käuflich erworben werden.</p>

    <h5>Qualitätsstandards</h5>
    <ul>
        <li>Referenten sind Experten ihres Fachgebiets</li>
        <li>Vorträge müssen qualitativ hochwertig und didaktisch wertvoll sein</li>
        <li>VIP-, Fach- und Schulungsvorträge sind werbefrei</li>
        <li>Aussagekräftige Titel, informative Unterpunkte, mindestens 500 Zeichen Inhaltsbeschreibung und ein passendes Bild zum Thema des Vortrags erforderlich</li>
    </ul>
    `
  },
  {
    language: "en",
    content: `
    <h3>Presentation Submission for LOUNGES 2027</h3>
    <p>Before you begin with your submission, please read the following information carefully.</p>
    <p><strong>Only if the mentioned deadlines and standards are met can the presentation be accepted.</strong></p>

    <h5>Important Dates</h5>
    <ul>
        <li><strong>Start of submission:</strong> August 15, 2025</li>
        <li><strong>Submission deadline:</strong> November 30, 2025</li>
        <li><strong>Confirmation deadline for submitted/incomplete presentations:</strong> November 30, 2025</li>
        <li><strong>No more submissions from:</strong> December 1, 2025</li>
    </ul>
      <br />
    <h4>Presentation Types</h4>
    <p>The following four presentation categories are available for selection.</p>

    <h6><strong>VIP Presentation</strong></h6>
    <ul>
        <li>Presentation together with a government agency representative</li>
        <li>Or presentation about projects that are/were implemented together with the client and presented together with at least 2 people</li>
        <li>Client means here: pharmaceutical manufacturer</li>
        <li>Presentation will be promoted on the website as well as separately via LinkedIn and other media</li>
        <li>Studio stage or ECV-Stage</li>
    </ul>

    <h6><strong>Expert Presentation *</strong></h6>
    <ul>
        <li>Expert knowledge, research results, guidelines, innovations, client projects</li>
        <li>Presentation will be promoted on the website as well as through the program via LinkedIn and other media individually</li>
        <li>Presentation room 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Training Presentation *</strong></h6>
    <ul>
        <li>Specific knowledge, skills, competencies. Serves to train beginners to experts</li>
        <li>Presentation will be promoted on the website as well as through the program via LinkedIn and other media individually</li>
        <li>Presentation room 1,2,3,6,7,8</li>
    </ul>

    <h6><strong>Marketing Presentation</strong></h6>
    <ul>
        <li>Value and benefits of products, services, ideas. Brand presentation. For potential customers, business partners.</li>
        <li>Presentation will be promoted on the website</li>
        <li>Open presentation area 4,5</li>
    </ul>

    <p><strong>Please note:</strong> VIP, expert and training presentations are generally recorded.</p>

    <p><em>*In exceptional cases, these can also not be recorded upon request. They will initially be placed on a waiting list and will be assigned to the schedule at the very end during program planning, if free slots are still available. Open presentation area 9</em></p>

    <h5>Important Notice Regarding Recordings and Usage Rights</h5>
    <p>VIP, expert and training presentations are recorded via audio and video. The recording rights belong to Inspire GmbH and are offered to participants as well as non-participants on the online platform. Access to the recordings can be purchased.</p>

    <h5>Quality Standards</h5>
    <ul>
        <li>Speakers are experts in their field</li>
        <li>Presentations must be of high quality and didactically valuable</li>
        <li>VIP, expert and training presentations are advertising-free</li>
        <li>Meaningful titles, informative bullet points, at least 500 characters content description and a suitable image related to the presentation topic required</li>
    </ul>
    `
  }
];

export default function LectureInfoStep({ onComplete, stepId, isCompleted }) {
  const { t, i18n } = useTranslation();
  const [isConfirmed, setIsConfirmed] = useState(false);
  
  // Get current language, fallback to German
  const currentLanguage = i18n.language || 'de';
  
  // Get information content based on current language
  const currentContent = useMemo(() => {
    return informationContent.find(content => content.language === currentLanguage) ||
           informationContent.find(content => content.language === 'de') ||
           informationContent[0];
  }, [currentLanguage]);

  const handleComplete = () => {
    if (isConfirmed) {
      onComplete(stepId);
    }
  };

  const handleCheckboxChange = (e) => {
    setIsConfirmed(e.target.checked);
  };

  return (
    <div className="h-100 d-flex flex-column">


      <div className="flex-grow-1">
        <MDBRow>
          <MDBCol>
            <div 
              className="information-content"
              dangerouslySetInnerHTML={{ __html: currentContent.content }}
              style={{
                lineHeight: '1.6',
                fontSize: '1rem'
              }}
            />
          </MDBCol>
        </MDBRow>
      </div>

      <div className="mt-4">
        <MDBCheckbox
          id="lectureInfoConfirmation"
          label={<strong>{t('I confirm that I have read and accept all information about the lectures')}</strong>}
          checked={isConfirmed}
          onChange={handleCheckboxChange}
          className="mb-3"
        />
        <div className="d-flex justify-content-between">
          <div></div>
          <MDBBtn 
            color="primary" 
            onClick={handleComplete}
            disabled={!isConfirmed}
          >
            {t('common.continue', 'Continue')}
          </MDBBtn>
        </div>
      </div>
    </div>
  );
}